import Index from '../components/companyGroupEmployerGS/Index';
import IndexIn from '../components/companyGroupEmployerGS/IndexIn';
import View from '@/components/common/view'
import EmployerEdit from '../components/companyGroupEmployerGS/Edit';
import EmployerEditBatch from '../components/companyGroupEmployerGS/EditBatch';
import EmployerFillin from '../components/companyGroupEmployerGS/Fillin';
import EmployerConfirm from '../components/companyGroupEmployerGS/Confirm';
import EmployerFillinPerson from '../components/companyGroupEmployerGS/FillinPerson';
import EmployerFillinPersonSuccess from '../components/companyGroupEmployerGS/FillinPersonSuccess';


export default [
	{
		path:'',
		component:View,
		children:[
			{
				path:'',
				component:Index
			},
			{
				path:'in',
				component:IndexIn
			},
			{
				path:'fillin/:id?',
				component:EmployerFillin
			},
			{
				path:'edit/:id',
				component:EmployerEdit
			},
			{
				path:'edit-batch/:id',
				component:EmployerEditBatch
			},
			{
				path:'confirm/:id?',
				component:EmployerConfirm
			},
			{
				path:'fillin-person/:policyId/:id',
				component:EmployerFillinPerson,
				meta:{
					hideLogin:true
				}
			},
			{
				path:'fillin-person-success',
				component:EmployerFillinPersonSuccess,
				meta:{
					hideLogin:true
				}
			}
		]
	},
]


// WEBPACK FOOTER //
// ./src/pages/haierProduct/router/companyGroupEmployerGS.js